const merge = (previous = [], changed = [], removed = []) => {
  const rows = new Map(previous.map(row => [String(row.id), row]));
  for (const id of removed) rows.delete(String(id));
  for (const row of changed) rows.set(String(row.id), row);
  return [...rows.values()];
};
// Cursor identity orders opaque revisions. An event itself is never a result.
export function applyMonitorUpdate(previous, cursor, update) {
  if (!update?.cursor || (!update.reset && (update.baseCursor !== cursor || !previous))) return null;
  const runChanges = { ...(update.reset ? {} : previous?.runChanges), ...update.runChanges };
  for (const id of update.removedRunChangeIds || []) delete runChanges[id];
  return { ...(update.reset ? {} : previous), ...update.overview, readModel: update.readModel, runChanges,
    runs: merge(update.reset ? [] : previous?.runs, update.runs, update.removedRunIds),
    operations: merge(update.reset ? [] : previous?.operations, update.operations, update.removedOperationIds),
    ...(Array.isArray(update.snapshotJobs) ? { snapshotJobs: merge(update.reset ? [] : previous?.snapshotJobs, update.snapshotJobs, update.removedSnapshotJobIds) } : {}) };
}
